import { render, staticRenderFns } from "./MyCompany.vue?vue&type=template&id=0efc1ee4&"
import script from "./MyCompany.vue?vue&type=script&lang=js&"
export * from "./MyCompany.vue?vue&type=script&lang=js&"
import style0 from "./MyCompany.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports